import React from 'react'

const Arrivals = () => {
  return (
    <>
        <h1>Arrivals</h1>
    </>
  )
}

export default Arrivals